<script>
  import Text from "$lib/Text.svelte";
  import Icon from "$lib/Icon.svelte";

  export let block;
  let active = 0;

  const mod = (n, m) => {
    return ((n % m) + m) % m;
  };

  let color = block?.fields?.[0]?.background || "black";

  const next = (prev = false) => {
    active = mod(active + (prev ? -1 : 1), block.fields.length);
    color = block?.fields?.[active]?.background || "black";
  };
</script>

<div
  class="w-screen overflow-hidden relative transition duration-300 {color ===
  'black'
    ? 'dark'
    : color === 'white'
    ? 'light'
    : 'gradient dark'}"
>
  <div
    class="flex transition duration-300 transform"
    style="width: {block.fields.length * 100}%; transform: translateX({-(
      100 * active
    ) / block.fields.length}%)"
  >
    {#each block.fields as { image, quote, customer, position, name, background }}
      <div class="w-screen flex-shrink-0 p-16 lg:p-24">
        <div
          class="max-w-4xl mx-auto flex flex-col lg:flex-row justify-between"
        >
          <div class="flex-shrink-0 lg:mr-8 mb-8 lg:mb-0">
            <div class="w-40 relative m-auto">
              <div class="rounded-full border-4 border-current overflow-hidden">
                <img src={image.url} alt={name} class="block w-full" />
              </div>
              <div class="absolute bottom-0 right-0">
                <img
                  src="/quote_{background === 'white' ? 'black' : 'white'}.png"
                  class="block w-12"
                  alt="quote"
                />
              </div>
            </div>
          </div>

          <div>
            <Text text={quote} class="text-xl font-black italic" />
            <div class="lg:flex justify-between items-center mt-8">
              <div><strong>{name}</strong> | {position}</div>
              <div class="flex-shrink-0 mt-4 lg:mt-0 flex">
                <img
                  src={customer.logo.url}
                  class="block grayscale h-16 m-auto {background === 'white'
                    ? ''
                    : 'invert'}"
                  alt={customer.customer[0].text}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    {/each}
  </div>
  {#if block.fields.length > 1}
    <div class="absolute inset-x-0 bottom-8 flex justify-center">
      {#each block.fields as field, index}
        <button
          class="block w-4 h-4 rounded-full border-4 mx-0.5 hover:bg-current transition {active ===
          index
            ? 'bg-current'
            : ''}"
          on:click={() => (active = index)}
        />
      {/each}
    </div>
    <button
      class="absolute inset-y-0 right-0 my-auto text-3xl lg:text-6xl focus:outline-none"
      on:click={() => next(false)}><Icon icon="chevron-right" /></button
    >
    <button
      class="absolute inset-y-0 left-0 my-auto text-3xl lg:text-6xl focus:outline-none"
      on:click={() => next(true)}><Icon icon="chevron-left" /></button
    >
  {/if}
</div>
